import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/field/Button';

import useAlert from 'hooks/useAlert';

import axios from 'services/axios';
import { PAYMENT } from 'services/consts';

import { setLoading } from 'stores/layoutSlice';
import { getClientCards } from 'stores/userSlice';

import AppLogger from 'utils/AppLogger';

let popup;

const AddCardPayTrButton = ({ nextStep, setCardLastFour }) => {
	const dispatch = useDispatch();
	const formMethods = useFormContext();
	const { showError } = useAlert();
	const { watch, handleSubmit } = formMethods;

	const { loading } = useSelector((state) => state?.layout);

	const checkPayment = async (id) => {
		dispatch(setLoading(true));
		try {
			const { data } = await axios.post(PAYMENT.CHECK_PAYMENT_METHOD, {
				paymentID: id
			});

			if (data.status === 'pending') {
				const timeout = setTimeout(() => {
					clearTimeout(timeout);
					checkPayment(id);
				}, 3 * 1000);
			} else {
				setCardLastFour(data?.cardLastFour);
				dispatch(setLoading(false));
				if (data.status === 'paid') {
					dispatch(getClientCards({ forceSync: true }));
					nextStep();
				} else {
					throw new Error(`Payment failed: ${JSON.stringify(data)}`);
				}
			}
		} catch (error) {
			AppLogger.error(error);
			showError();
			dispatch(setLoading(false));
		}
	};

	const completeCreditPayment = async () => {
		dispatch(setLoading(true));
		popup = window.open('/payment-redirect-tr.html', '_blank');

		try {
			const cardExpiryDates = watch('cardExpiry')?.split('/');
			const { data, status } = await axios.post(PAYMENT.ADD_PAYMENT_METHOD, {
				cardInfo: {
					ccOwner: watch('cardHolderName'),
					cardNumber: watch('cardNumber')?.replace?.(/\s/g, ''),
					expiryMonth: cardExpiryDates[0].toString(),
					expiryYear: cardExpiryDates[1].toString(),
					cvv: watch('cvv')
				}
			});

			if (status === 200) {
				const { transactionUrl } = data;
				const transactionResponse = JSON.parse?.(transactionUrl);

				if (transactionResponse?.code === 200 && transactionResponse?.response) {
					checkPayment(data.paymentID);
					popup.document.write(transactionResponse.response);
					popup.document?.body?.onload?.();
				} else {
					throw new Error(`Payment failed: ${JSON.stringify(data)}`);
				}
			} else {
				popup.close();
				showError();
				AppLogger.error(data);
				dispatch(setLoading(false));
			}
		} catch (error) {
			popup.close();
			showError();
			AppLogger.error(error);
		} finally {
			dispatch(setLoading(false));
		}
	};

	return (
		<Button
			label={'completeAddPaymentMethod'}
			loading={loading}
			onClick={handleSubmit(completeCreditPayment, AppLogger.error)}
			className="payment-form-button"
		/>
	);
};

export default AddCardPayTrButton;
